// @flow

import React from 'react';
import styles from './modalWithTable.scss';
import ZoomTable from '../zoomTable/zoomTable';

import Modal from '../modal/modal';

type Props = {
  showModal: boolean,
  closeModal: Function,
  modalTheme?: Object,
  tableKey: string,
  tableData: Array<Any>,
  tableActionFunctions?: Object,
  title: string,
  loading?: boolean
};

class ModalWithTable extends React.Component<Props> {
  constructor(props: Object) {
    super(props);
    this.modalTheme = this.props.modalTheme;
  }
  closeModal() {
    this.props.closeModal(false); // false to close the modal
  }
  handleHandoverSummaryBack() {
    // eslint-disable-next-line
    console.log(' handleHandoverSummaryBack Btn');
  }
  modalTheme: Object;
  render() {
    return (
      <Modal
        showLoader={false}
        showModal={this.props.showModal}
        title={this.props.title}
        closeModal={() => {
          this.closeModal();
        }}
        modalTheme={this.modalTheme}
        onBackBtnClick={() => this.handleHandoverSummaryBack()}
      >
        <div className={`${styles.collectionsHandoverModalWrapper}`}>
          <ZoomTable
            configKey={this.props.tableKey}
            tableDataLength={
              this.props.tableData && this.props.tableData.length
            }
            tableData={this.props.tableData}
            actionFunctions={this.props.tableActionFunctions}
            loading={this.props.loading}
          />
        </div>
      </Modal>
    );
  }
}

export default ModalWithTable;
